import VueI18n from 'vue-i18n'
import Vue from 'vue'

//引入element的语言包
import localeLib from 'element-ui/lib/locale' //本地
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //中文
import zhTWElemment from 'element-ui/lib/locale/lang/zh-TW' //e引入elementUI繁体中文语言包
import enLocale from 'element-ui/lib/locale/lang/en' // 引入element英文语言包 

// 引入需要语言包也可是js文件，export default抛出语言包的对象
import hk from './zh-HK.json'
import zh from './zh-CN.json'
import en from './en-US.json'

Vue.use(VueI18n)

// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  messages: {
    zh: Object.assign(zh, zhLocale),
    hk: Object.assign(hk, zhTWElemment),
    tw: Object.assign(hk, zhTWElemment),
    en: Object.assign(en, enLocale),
  },
})
// 设置语言
localeLib.i18n((key, value) => i18n.t(key, value))
export default i18n
